import { render, staticRenderFns } from "./Dialogs.vue?vue&type=template&id=f982a044&"
import script from "./Dialogs.vue?vue&type=script&lang=js&"
export * from "./Dialogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f982a044')) {
      api.createRecord('f982a044', component.options)
    } else {
      api.reload('f982a044', component.options)
    }
    module.hot.accept("./Dialogs.vue?vue&type=template&id=f982a044&", function () {
      api.rerender('f982a044', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/Audience/Segment/Components/Dialogs.vue"
export default component.exports